export default __webpack_public_path__ + "static/media/My_Family_Medical_Treatment.145fe33f.svg";